
export default {
    async getAllContracts() {
        return new Promise(function (resolve, reject) {
            http.get('api/client-report/contract')
                .then(response => {
                    resolve(response.data);
                }, error => {
                    reject(error);
                });
        });
    },
    async getStats(range = null) {
        return new Promise(function (resolve, reject) {
            let url = 'api/client-report/stats';

            if (range && (range.from || range.to)) {
                const params = [];
                if (range.from) {
                    params.push(`from=${range.from}`);
                }
                if (range.to) {
                    params.push(`to=${range.to}`);
                }
                url = url + '?' + params.join('&');
            }

            http.get(url)
                .then(response => {
                    resolve(response.data.data);    // do not know now, why to put data twice...
                }, error => {
                    reject(error);
                });
        });
    },
    async getHistory(range = null) {
        return new Promise(function (resolve, reject) {
            let url = 'api/client-report/history';

            if (range && (range.from || range.to)) {
                const params = [];
                if (range.from) {
                    params.push(`from=${range.from}`);
                }
                if (range.to) {
                    params.push(`to=${range.to}`);
                }
                url = url + '?' + params.join('&');
            }

            http.get(url)
                .then(response => {
                    resolve(response.data.data);    // do not know now, why to put data twice...
                }, error => {
                    reject(error);
                });
        });
    },

    async getComposition(composeBy = null) {
        return new Promise(function (resolve, reject) {
            let url = `api/client-report/composition`;
            if(composeBy) {
                url = url + '?composeBy=' + composeBy;
            }
            http.get(url)
                .then(response => {
                    resolve(response.data);
                }, error => {
                    reject(error);
                });
        });
    },

    async getContract(id) {
        return new Promise(function (resolve, reject) {
            http.get(`api/client-report/contract/${id}`)
                .then(response => {
                    resolve(response.data);
                }, error => {
                    reject(error);
                });
        });
    },

    async getContractStats(contractId, range = null) {
        return new Promise(function (resolve, reject) {
            let url = `api/client-report/contract/${contractId}/stats`;
            if (range && (range.from || range.to)) {
                const params = [];
                if (range.from) {
                    params.push(`from=${range.from}`);
                }
                if (range.to) {
                    params.push(`to=${range.to}`);
                }
                url = url + '?' + params.join('&');
            }
            http.get(url)
                .then(response => {
                    resolve(response.data);
                }, error => {
                    reject(error);
                });
        });
    },

    async getContractComposition(contractId, composeBy = null) {
        let url = `api/client-report/contract/${contractId}/composition`;
        if(composeBy) {
            url = url + '?composeBy=' + composeBy;
        }
        return new Promise(function (resolve, reject) {
            http.get(url)
                .then(response => {
                    resolve(response.data);
                }, error => {
                    reject(error);
                });
        });
    },

    async getContractHistory(contractId) {
        return new Promise(function (resolve, reject) {
            http.get(`api/client-report/contract/${contractId}/history`)
                .then(response => {
                    resolve(response.data);
                }, error => {
                    reject(error);
                });
        });
    },
    async getTransactions(contractId) {
        return new Promise(function (resolve, reject) {
            http.get(`api/client-report/contract/${contractId}/transactions`)
                .then(response => {
                    resolve(response.data);
                }, error => {
                    reject(error);
                });
        });
    },
    async getTrades(contractId) {
        return new Promise(function (resolve, reject) {
            http.get(`api/client-report/contract/${contractId}/trades`)
                .then(response => {
                    resolve(response.data);
                }, error => {
                    reject(error);
                });
        });
    },
    async getStrategies(contractId) {
        return new Promise(function (resolve, reject) {
            http.get(`api/client-report/contract/${contractId}/strategies`)
                .then(response => {
                    resolve(response.data);
                }, error => {
                    reject(error);
                });
        });
    },

    async getContractStrategy(id) {
        return new Promise(function (resolve, reject) {
            http.get(`api/client-report/contract-strategy/${id}`)
                .then(response => {
                    resolve(response.data);
                }, error => {
                    reject(error);
                });
        });
    },

    async getContractStrategyStats(contractStrategyId, range = null) {
        return new Promise(function (resolve, reject) {
            let url = `api/client-report/contract-strategy/${contractStrategyId}/stats`;
            if (range && (range.from || range.to)) {
                const params = [];
                if (range.from) {
                    params.push(`from=${range.from}`);
                }
                if (range.to) {
                    params.push(`to=${range.to}`);
                }
                url = url + '?' + params.join('&');
            }
            http.get(url)
                .then(response => {
                    resolve(response.data);
                }, error => {
                    reject(error);
                });
        });
    },

    async getContractStrategyComposition(contractStrategyId, composeBy = null) {
        let url = `api/client-report/contract-strategy/${contractStrategyId}/composition`;
        if(composeBy) {
            url = url + '?composeBy=' + composeBy;
        }
        return new Promise(function (resolve, reject) {
            http.get(url)
                .then(response => {
                    resolve(response.data);
                }, error => {
                    reject(error);
                });
        });
    },

    async getContractStrategyHistory(contractStrategyId) {
        return new Promise(function (resolve, reject) {
            http.get(`api/client-report/contract-strategy/${contractStrategyId}/history`)
                .then(response => {
                    resolve(response.data);
                }, error => {
                    reject(error);
                });
        });
    },

    async getContractStrategyTransactions(contractStrategyId) {
        return new Promise(function (resolve, reject) {
            http.get(`api/client-report/contract-strategy/${contractStrategyId}/transactions`)
                .then(response => {
                    resolve(response.data);
                }, error => {
                    reject(error);
                });
        });
    },

    async getContractStrategyTrades(contractStrategyId) {
        return new Promise(function (resolve, reject) {
            http.get(`api/client-report/contract-strategy/${contractStrategyId}/trades`)
                .then(response => {
                    resolve(response.data);
                }, error => {
                    reject(error);
                });
        });
    },

    async getContractInstructions(contractId) {
        return new Promise(function (resolve, reject) {
            http.get(`api/client-report/contract/${contractId}/instructions`)
                .then(response => {
                    resolve(response.data);
                }, error => {
                    reject(error);
                });
        });
    },

    async getContractStrategyInstructions(contractStrategyId) {
        return new Promise(function (resolve, reject) {
            http.get(`api/client-report/contract-strategy/${contractStrategyId}/instructions`)
                .then(response => {
                    resolve(response.data);
                }, error => {
                    reject(error);
                });
        });
    },
}
